import { Boxes, LinkIcon } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.24 — Mini App katalogi SEO. Mini-ilova katalog yozuvlari (ilova + title +
 * description). CRUD `/admin/seo/miniapp` (fail-soft).
 */
export function MiniAppSeoScreen() {
  return (
    <SeoConfigTable
      screenId="A12.24"
      title={S.miniAppSeo}
      addLabel={S.addMiniApp}
      path="/admin/seo/miniapp"
      listKey="entries"
      searchKeys={['app', 'title']}
      icon={<Boxes size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'app', placeholder: S.app },
        { name: 'title', placeholder: S.metaTitleCol },
        { name: 'description', placeholder: S.metaDesc },
      ]}
      columns={[
        { key: 'app', header: S.app, type: 'text' },
        { key: 'title', header: S.metaTitleCol, type: 'text' },
        { key: 'description', header: S.metaDesc, type: 'longtext' },
      ]}
    />
  )
}

/**
 * A12.25 — Deep-link preview sozlamalari. Deep-link path → sarlavha + rasm.
 * CRUD `/admin/seo/deeplink` (fail-soft).
 */
export function DeepLinkPreviewScreen() {
  return (
    <SeoConfigTable
      screenId="A12.25"
      title={S.deepLink}
      addLabel={S.addDeepLink}
      path="/admin/seo/deeplink"
      listKey="entries"
      searchKeys={['path', 'title']}
      icon={<LinkIcon size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'path', placeholder: '/invite/*', mono: true },
        { name: 'title', placeholder: S.metaTitleCol },
        { name: 'image', placeholder: S.image, mono: true },
      ]}
      columns={[
        { key: 'path', header: S.path, type: 'text' },
        { key: 'title', header: S.metaTitleCol, type: 'text' },
        { key: 'image', header: S.image, type: 'text' },
      ]}
    />
  )
}
